import React ,{useEffect} from "react";
import RadioComponent from '../../Components/RadioComponent';

/*
This is a component that displays all the information of a radio in the edit pop up window when we edit a data element.
At this point we meet radio only inside a form data element.
*/
const EditRadioComponent = (props) => {
    const {
        index,
        index2,
        componentsInfo,
        setComponentsInfo,
        rowsComponentsIds,
        setRowsComponentsIds,
        setAdded,
        clickedEdit,
        initComponentsInfo,
        deleteComps,
        setDeleteComps,
        editor,
        infoSummary,
        setInfoSummary
    } = props

    const [lockDeleteOption, setLockDeleteOption] = React.useState(false);
    const [clickedDeleteFirst, setClickedDeleteFirst] = React.useState(false);


    useEffect( () => {

        if(initComponentsInfo === true){

            
            const domComponents = editor.DomComponents;

            const tempComponentsInfo = [...componentsInfo]
            const tempInfoSummary = [...infoSummary];
            const options = [];

            if(tempInfoSummary[index2] !== undefined && tempInfoSummary[index2].labels !== undefined){

                componentsInfo[index].info[index2].ids.forEach( insideId =>{
                    
                    const insideComponent = domComponents.componentsById[insideId];

                    if(insideComponent !== undefined){
                        insideComponent.attributes.components.models.forEach( insideComp2 => {
                            if(insideComp2.attributes.tagName === 'label'){
        
                                const insideContent = insideComp2.attributes.components.models[0].attributes.content;
        
                                options.push(insideContent);
        
                            }
                        })

                        tempComponentsInfo[index].info[index2].labels = options;

                    }
                    

                })

                tempInfoSummary[index2].labels = options;

            } 
            setComponentsInfo(tempComponentsInfo);
            setInfoSummary(tempInfoSummary);
                
        }

    }, [clickedEdit,initComponentsInfo])

    useEffect( () => {
        if(clickedDeleteFirst === true){

            const tempComponentsInfo = [...componentsInfo];
            const lengthOptions = tempComponentsInfo[index].info[index2].labels.length;

            if(lengthOptions === 1){
                setLockDeleteOption(true);
            }
            setClickedDeleteFirst(false);
        }
        if(lockDeleteOption === true){
            setTimeout(() => {
                setLockDeleteOption(false)  
            }, 2000);
        }

    },[clickedDeleteFirst])

    const handleOptionLabel = (val, index3) => {

        const tempInfoSummary = [...infoSummary];
        tempInfoSummary[index2].labels[index3] = val.target.value;
        setInfoSummary(tempInfoSummary);
   
        const tempComponentsInfo =[...componentsInfo];
        tempComponentsInfo[index].info[index2].labels[index3] = val.target.value;
        setComponentsInfo(tempComponentsInfo);

        setAdded(true)
    }


    /* 
    This function delete the radio component of the edited data element window and of the information about the block that we keep 
    and renders again
    */ 
    const deleteElement = () => {
        
        const tempDeleteComps = [...deleteComps];
        componentsInfo[index].info[index2].ids.forEach( id => {
            tempDeleteComps.push(id);
        })
        setDeleteComps(tempDeleteComps)

        
        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].div.splice(index2,1);
        tempComponentsInfo[index].info.splice(index2,1);
        setComponentsInfo(tempComponentsInfo);
        
        const tempRowsComponentsIds = [...rowsComponentsIds];
        tempRowsComponentsIds[index].insideIds.splice(index2,1);
        setRowsComponentsIds(tempRowsComponentsIds);

        setAdded(true);
    }

    const checkIfExistOtherId = (index3) => {
        let exists = false;

        componentsInfo[index].info[index2].ids.forEach( (id, indexId) => {
            if(id !== -1 && index3 !== indexId){
                exists = true;
            }
        } )

        return exists;
    }

    const checkIfLastId = (index3) => {
        
        let exists = false;

        const id = componentsInfo[index].info[index2].ids[index3]
        const lastId = rowsComponentsIds[index].insideIds[index2]

        if (id !== -1 && id === lastId){
            exists = true;
        }

        return exists;
        

    }

    const deleteOption = (index3) => {
        
        const optionsLength = componentsInfo[index].info[index2].labels.length;
        if(index3 === 0 && optionsLength === 1){
            setClickedDeleteFirst(true)
        }
        if(optionsLength >1){

            if( checkIfExistOtherId(index3) === true){

                if(checkIfLastId(index3) === true){
                    const tempRowsComponentsIds = rowsComponentsIds;
                    tempRowsComponentsIds[index].insideIds[index2] = componentsInfo[index].info[index2].ids[index3-1];
                    setRowsComponentsIds(tempRowsComponentsIds);
                }

                const tempDeleteComps = [...deleteComps];
                tempDeleteComps.push(componentsInfo[index].info[index2].ids[index3]);
                setDeleteComps(tempDeleteComps)

                const tempComponentsInfo = [...componentsInfo];
                tempComponentsInfo[index].info[index2].labels.splice(index3,1);
                tempComponentsInfo[index].info[index2].ids.splice(index3,1);
                setComponentsInfo(tempComponentsInfo);

            }
            else{
                const tempComponentsInfo = [...componentsInfo];
                tempComponentsInfo[index].info[index2].ids[index3+1] = tempComponentsInfo[index].info[index2].ids[index3];
                tempComponentsInfo[index].info[index2].labels.splice(index3,1);
                tempComponentsInfo[index].info[index2].ids.splice(index3,1);
                setComponentsInfo(tempComponentsInfo);
            }
            
        } 
        setAdded(true);
    }

    const addOption= () => {
        
        const tempComponentsInfo = [...componentsInfo];
        const lengthOptions = tempComponentsInfo[index].info[index2].labels.length;
        tempComponentsInfo[index].info[index2].labels.push(`Radio${(lengthOptions+1).toString()}`);
        tempComponentsInfo[index].info[index2].ids.push(-1);
        setComponentsInfo(tempComponentsInfo);
        setAdded(true);

    }

    return(
        <RadioComponent 
            deleteComponent={deleteElement}
            options={componentsInfo[index].info[index2].labels}
            handleOptionLabel={handleOptionLabel}
            lockDeleteOption={lockDeleteOption}
            deleteOption={deleteOption}
            addOption={addOption}
        />
    )
}

export default EditRadioComponent;